<template>
    <v-content>
        <v-app-bar absolute flat dense color="blue" dark >
            <v-toolbar-title class="body-1">{{transactionId}}</v-toolbar-title>
            <v-spacer></v-spacer>
            <transaction-menu/>
        </v-app-bar>

        <v-progress-circular
                style="position:fixed; left: 50%; top: 50%; transform: translate(-50%, -50%);"
                v-if="!content"
                :size="130"
                :width="15"
                color="blue"
                indeterminate
        ></v-progress-circular>

        <v-sheet
                fill-height class="pt-10 grey lighten-4" height="100vh"
        >
            <history-component
                    v-if="currentView == 'history'"
                    class="pt-10"
            >
            </history-component>
            <PoslogDisplayComponent
                    v-if="currentView != 'history'"
            >
            </PoslogDisplayComponent>
        </v-sheet>

    </v-content>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import HistoryComponent from "@/components/transaction/HistoryComponent"
import {TRANSACTION_NS} from "@/store/modules/transaction/constants";
import PoslogDisplayComponent from "@/components/transaction/PoslogDisplayComponent";
import TransactionMenu from "@/components/transaction/TransactionMenu";
import {NOTIFICATION_NS} from "@/store/modules/notification/constants";
import {parameters} from "@/parameters";

export default {
        name: "TransactionView",
        components: {TransactionMenu, PoslogDisplayComponent, HistoryComponent},
        computed: {
            ...mapGetters(TRANSACTION_NS, [
                'transactionId',
                'messageDateTime',
                'version',
                'currentView',
                'anonymized',
                'poslogApi',
                'content'
            ])
        },
        methods: {
          ...mapActions(TRANSACTION_NS, [
            'refreshPoslogData',
            'fetchXML',
            'cleanPoslogData',
            'switchTo'
          ]),
          ...mapActions(NOTIFICATION_NS, [
            'addNotification'
          ])
        },
        created() {
          const askAnonymised = !parameters.showRawData || this.$route.params.anonymized != 'raw';

          if (!this.poslogApi) {
                this.refreshPoslogData({
                    transactionId: this.$route.params.transactionId,
                    messageDateTime: this.$route.params.messageDateTime,
                    version:  this.$route.params.version,
                    anonymized: askAnonymised
                });
            }
            this.switchTo(this.$route.params.view);

          if(askAnonymised) {
            this.addNotification({
              message :"You are viewing a poslog with anonymised data."
            });
          }
        },
        beforeRouteUpdate(to, from, next) {
            const askAnonymised = !parameters.showRawData ||  to.params.anonymized != 'raw';
            if ((this.transactionId != to.params.transactionId) || (this.anonymized != askAnonymised)) {
                // all data is impacted, we need to refresh everything
                this.refreshPoslogData({
                    transactionId: to.params.transactionId,
                    messageDateTime: to.params.messageDateTime,
                    version: to.params.version,
                    anonymized: askAnonymised
                });
            } else if(to.params.view == 'xml' && (this.messageDateTime != to.params.messageDateTime || this.version != to.params.version)) {
                // Change only the xml so only fetch new XML version
                this.fetchXML({
                    messageDateTime: to.params.messageDateTime,
                    version: to.params.version
                })
            }

            this.switchTo(to.params.view);
            next();
        },
        destroyed() {
            this.cleanPoslogData();
        }

    }
</script>